import { render, staticRenderFns } from "./PlaylistContentList.vue?vue&type=template&id=0f54229a&"
import script from "./PlaylistContentList.vue?vue&type=script&lang=js&"
export * from "./PlaylistContentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports